import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import {
  type DynamicTextConfig,
  FONT_FAMILY_MAP,
  FONT_WEIGHT_MAP,
  type TextTag,
  TEXT_SIZE_MAP,
} from './dynamic-text.types';

@Component({
  selector: 'app-dynamic-text',
  templateUrl: './dynamic-text.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DynamicText {
  readonly config = input.required<DynamicTextConfig>();

  protected readonly tag = computed<TextTag>(() => this.config().tag || 'p');
  protected readonly text = computed(() => this.config().text);
  protected readonly size = computed(() => TEXT_SIZE_MAP[this.config().size || 'sm']);
  protected readonly fontWeight = computed(() => {
    const override = this.config().fontWeight;
    return override ? FONT_WEIGHT_MAP[override] : this.size().fontWeight;
  });
  protected readonly color = computed(() => this.config().color || 'var(--body-color)');
  protected readonly fontFamily = computed(() => FONT_FAMILY_MAP[this.config().fontFamily || 'sans']);
  protected readonly alignment = computed(() => this.config().alignment || 'left');
  protected readonly gradient = computed(() => {
    const g = this.config().gradient;
    return g ? `gradient-${g}` : undefined;
  });
  protected readonly whiteSpace = computed(() => this.config().whiteSpace);
}
